import { useLanguage } from "@/context/LanguageContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { Phone } from "lucide-react";
import { SITE, telHref, waHref, DEFAULT_WA_TEXT } from "@/config/site";

// Call + WhatsApp action pills using the owner-confirmed PRIMARY number.
export const CallButton = ({ className = "", testId = "call-now-button", label = "Call Now" }) => {
  const { t } = useLanguage();
  return (
  <a
    href={telHref(SITE.phonePrimary.tel)}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 ${className}`}
    aria-label={t("Call {brand} at {phone}", { brand: SITE.brand, phone: SITE.phonePrimary.display })}
  >
    <Phone className="h-4 w-4" aria-hidden="true" />
    <span>{typeof label === "string" ? t(label) : label}</span>
  </a>
  );
};

export const WhatsAppButton = ({
  className = "",
  testId = "whatsapp-button",
  label = "WhatsApp",
  text = DEFAULT_WA_TEXT,
}) => {
  const { t } = useLanguage();
  return (
  <a
    href={waHref(SITE.phonePrimary.wa, t(text))}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 ${className}`}
    aria-label={t("Message {brand} on WhatsApp", { brand: SITE.brand })}
  >
    <WhatsAppIcon className="h-4 w-4" aria-hidden="true" />
    <span>{typeof label === "string" ? t(label) : label}</span>
  </a>
  );
};
